<template>
  <Modal ref="modal">
    <textarea
      v-model="remarks"
      placeholder="Remarques à l'attention du technicien"
      class="form-control" />

    <template #buttons>
      <button
        class="btn-secondary"
        :disabled="loading"
        @click="hide">
        Annuler
      </button>
      <button
        class="btn-primary"
        :class="{ 'loading': loading }"
        :disabled="loading"
        style="margin-left: 5px;"
        @click="submit">
        Enregistrer
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from "@/components/modals/Modal.vue";

export default {
  name: "EditInterventionRemarksModal",
  components: {
    Modal,
  },

  emits: ["change"],
  data() {
    return {
      intervention: null,
      remarks: null,
      loading: false,
    };
  },
  methods: {
    show(intervention) {
      this.intervention = intervention;
      this.remarks = intervention.remarks;
      this.loading = false;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
      this.intervention = null;
      this.remarks = null;
      this.loading = false;
    },
    submit() {
      this.loading = true;
      
      this.$services.intervention.patch(
        this.intervention.id,
        {
          remarks: this.remarks,
        },
      )
        .then((response) => {
          this.$emit(
            "change",
            {
              remarks: response.data.remarks,
            },
          );
          this.hide();
        });
    },
    
  },
};

</script>

<style lang="scss" scoped>


</style>